import roundToDecimals from "PFCore/helpers/round_to_decimals";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

import { checkIsANumber } from "../../../utils/utils";
import Tile from "../../common/tile";
import css from "./platform_usage_tiles.module.scss";

const PlatformUsageTiles = ({ data }) => {
  const { t } = useTranslation("insights", { keyPrefix: "platformUsageTiles" });

  return (
    <div className={css.platformUsageTiles}>
      <div className={css.platformUsageRow}>
        <Tile className={css.platformUsageTile}>
          <h2>{t("totalActiveUsers")}</h2>
          <p>{checkIsANumber(roundToDecimals(data.total_user))}</p>
        </Tile>
        <Tile className={css.platformUsageTile}>
          <h2>{t("usersExpressingInterest")}</h2>
          <p>{checkIsANumber(roundToDecimals(data.num_users_interested))}</p>
        </Tile>
        <Tile className={css.platformUsageTile}>
          <h2>{t("rolesUsersInterested")}</h2>
          <p>{checkIsANumber(roundToDecimals(data.num_roles_interested))}</p>
        </Tile>
      </div>
      <div className={css.platformUsageRow}>
        <Tile className={css.platformUsageTile}>
          <h2>{t("avgRolesInterestedPerUser")}</h2>
          <p>{checkIsANumber(roundToDecimals(data.avg_interest_roles_per_user))}</p>
        </Tile>
        <Tile className={css.platformUsageTile}>
          <h2>{t("interestedUsersShortlisted")}</h2>
          <p>{checkIsANumber(roundToDecimals(data.num_shortlisted_interested))}</p>
        </Tile>
        <Tile className={css.platformUsageTile}>
          <h2>{t("interestedUsersShortlistedPercent")}</h2>
          <p>{checkIsANumber(Math.round(roundToDecimals(data.shortlist_from_interest_rate) * 100))}%</p>
        </Tile>
      </div>
    </div>
  );
};

PlatformUsageTiles.propTypes = {
  data: PropTypes.shape({
    num_users_interested: PropTypes.number,
    num_roles_interested: PropTypes.number,
    avg_interest_roles_per_user: PropTypes.number,
    num_shortlisted_interested: PropTypes.number,
    shortlist_from_interest_rate: PropTypes.number,
    total_user: PropTypes.number
  })
};

export default PlatformUsageTiles;
